// redux/ai/aiApi.js
import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";

export async function sendAiChatApi(payload) {
  // payload: { message, provider, history, useTaskContext }
  return await api.post(`${apiPath.API_URL}${apiPath.ai.chat}`, payload);
}

export async function fetchAiStatusApi() {
  return await api.get(`${apiPath.API_URL}${apiPath.ai.status}`);
}

export async function fetchAiRecentApi() {
  return await api.get(`${apiPath.API_URL}${apiPath.ai.recent}`);
}
